import { Location_Metrics_Mobile_Pay_Filter } from '@occc/graphql';

export const getMobilePayFilterVariable = (
  value: Location_Metrics_Mobile_Pay_Filter,
): Location_Metrics_Mobile_Pay_Filter | undefined => {
  if (value === Location_Metrics_Mobile_Pay_Filter.MobilePayOnly) {
    return Location_Metrics_Mobile_Pay_Filter.MobilePayOnly;
  }

  return undefined;
};
